import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { NotificationOptDialogData } from '../dialogs-data/notification-opt-dialog-data';
import { NotificationOptDialogComponent } from '../dialogs/notification-opt-dialog/notification-opt-dialog.component';

@Injectable()
export class NotificationOptDialogService {

    constructor(private dialog: MatDialog) { }
    matDialogRef: MatDialogRef<NotificationOptDialogComponent>;

    open(notificationOptDialogData: NotificationOptDialogData) {
        const matDialogConfig = new MatDialogConfig();
        matDialogConfig.panelClass = 'myapp-dialog';
        matDialogConfig.width = '30%';
        matDialogConfig.data = notificationOptDialogData;
        matDialogConfig.disableClose = true;
        matDialogConfig.hasBackdrop = true;
        this.matDialogRef = this.dialog.open(NotificationOptDialogComponent, matDialogConfig);
    }

    confirmed(): Observable<any> {
        return this.matDialogRef.afterClosed().pipe(
            take(1),
            map(res => {
                return res;
            })
        );
    }
}
